var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxoutlineuserReceive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.2,7c0-3.2,2.6-5.8,5.8-5.8s5.8,2.6,5.8,5.8s-2.6,5.8-5.8,5.8S6.2,10.2,6.2,7z M7.8,7 c0,2.3,1.9,4.2,4.2,4.2s4.2-1.9,4.2-4.2S14.3,2.8,12,2.8S7.8,4.7,7.8,7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7,22c0-4.3,4.2-7.8,9.3-7.8 c1,0,2,0.1,3,0.4c0.4,0.1,0.6,0.5,0.5,0.9c-0.1,0.4-0.5,0.6-0.9,0.5c-0.8-0.2-1.7-0.3-2.6-0.3c-4.3,0-7.8,2.8-7.8,6.2 c0,0.4-0.3,0.8-0.7,0.8S2.7,22.4,2.7,22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8,21.5c-0.3-0.3-0.7-0.7-0.9-1.1 c-0.4-0.7-0.7-1.6-0.7-2.4c0-1.2,0.5-2.4,1.3-3.3c0.9-0.9,2.1-1.4,3.4-1.4c1.4,0,2.7,0.6,3.5,1.6c0.8,0.9,1.2,2,1.2,3.2 c0,0.4-0.1,0.8-0.2,1.1c-0.1,0.5-0.3,0.9-0.5,1.3c-0.8,1.4-2.4,2.3-4,2.3C16.8,22.8,15.7,22.3,14.8,21.5z M15.7,15.7 c-0.6,0.6-0.9,1.4-0.9,2.3c0,0.6,0.2,1.2,0.5,1.7c0.2,0.3,0.4,0.5,0.6,0.7c0.6,0.6,1.4,0.9,2.2,0.9c1.1,0,2.2-0.6,2.8-1.6 c0.2-0.3,0.3-0.6,0.4-0.9c0.1-0.3,0.1-0.5,0.1-0.8c0-0.8-0.3-1.6-0.8-2.2c-0.6-0.7-1.5-1.1-2.4-1.1 C17.1,14.8,16.3,15.1,15.7,15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3,18c-0.2,0-0.3,0.1-0.4,0.2l-0.2,0.2v-2.2c0-0.4-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6v2.2l-0.2-0.2 c-0.2-0.2-0.6-0.2-0.9,0c-0.2,0.2-0.2,0.6,0,0.9l1.2,1.2c0.1,0,0.1,0.1,0.2,0.1c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0.1,0 c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0.1,0,0.1-0.1,0.2-0.1c0,0,0,0,0,0l1.2-1.2c0.2-0.2,0.2-0.6,0-0.9C19.6,18.1,19.4,18,19.3,18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxoutlineuserReceive);
export default __webpack_public_path__ + "static/media/vuesaxoutlineuser-receive.2a134fbf8f23580c1ec1df3093a3a870.svg";
export { ForwardRef as ReactComponent };